import React, { createContext } from 'react';

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const contextValue = {}; // You can define your state and functions here

  return (
    <NotificationContext.Provider value={contextValue}>
      {children}
    </NotificationContext.Provider>
  );
};
